<template>
  <van-popup v-model="visible" round position="center" :close-on-click-overlay="false">
    <div class="bind-agent-message-dialog">
      <div class="message-text">
        <MyPLabel v-if="mode === 'confirm'" :str="$t('lang.AgentProfile.k017')" :numsOption="confirmLabelNums" />
        <template v-else>{{ message }}</template>
      </div>
      <div class="action-row">
        <button type="button" class="action-btn confirm-btn" @click="handleConfirm">{{ $t('lang.BaseModule.k069') }}</button>
        <button type="button" class="action-btn cancel-btn" @click="handleCancel">{{ $t('lang.BaseModule.k067') }}</button>
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: 'BindAgentMessageDialog',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: '',
    },
    mode: {
      type: String,
      default: 'error',
    },
    nickname: {
      type: String,
      default: '',
    },
  },
  computed: {
    confirmLabelNums() {
      return [{ value: this.nickname || '' }]
    },
    visible: {
      get() {
        return this.show
      },
      set(val) {
        if (!val) {
          this.$emit('close')
        }
      },
    },
  },
  methods: {
    handleConfirm() {
      this.$emit('confirm')
    },
    handleCancel() {
      this.$emit('cancel')
    },
  },
}
</script>

<style lang="scss" scoped>
.bind-agent-message-dialog {
  width: 311px;
  padding: 16px 12px;
  background: #ffffff;
  border-radius: 16px;
  box-sizing: border-box;

  .message-text {
    padding: 12px;
    font-family: var(--string-font);
    font-weight: var(--fw-400);
    font-size: var(--fs-14);
    line-height: var(--lh-title-20);
    color: #666666;
    text-align: center;
    word-break: break-word;
  }

  .action-row {
    display: flex;
    margin-top: 16px;

    > * + * {
      margin-left: 16px;
    }
  }

  .action-btn {
    flex: 1;
    min-width: 0;
    min-height: 52px;
    padding: 6px 24px;
    border-radius: 12px;
    font-family: var(--string-font);
    font-weight: var(--fw-400);
    font-size: var(--fs-14);
    line-height: var(--lh-title-20);
  }

  .confirm-btn {
    border: none;
    background: #f8e5bd;
    color: #925e0d;
  }

  .cancel-btn {
    border: 1px solid #e6e5e7;
    background: #ffffff;
    color: #666666;
  }
}
</style>
<style lang="scss">
html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .bind-agent-message-dialog {
    .action-row {
      > * + * {
        margin-left: 0;
        margin-right: 16px;
      }
    }
  }
}
</style>
